import { Outlet } from "react-router";

import { Titlebar } from "./titlebar";
import { CopilotSidebar } from "../../../features/copilot";

export function AppLayout({ name, children }: React.PropsWithChildren<{ name: string }>) {
  return (
    <>
      <Titlebar title={name} />
      <div className="overflow-hidden flex flex-row">
        <main className="flex-1 overflow-y-auto">{children ?? <Outlet />}</main>
        <CopilotSidebar />
      </div>
    </>
  );
}
